import AutoStoriesIcon from "@mui/icons-material/AutoStories";
import { FooterListButton } from "../../components/UIComponents/Buttons";
import { FooterListTitle } from "../../components/UIComponents/Typography";
import useMediaQuery from "../../hooks/useMediaQuery";

export default function FooterBookList() {
  const isDesktop = useMediaQuery("(min-width: 960px)");
  return (
    <ul className="prose dark:prose-invert max-w-none prose-reset-list prose-hr:m-0 prose-link prose-a:font-normal w-full lg:w-64 m-0 p-0">
      <FooterListTitle className={isDesktop ? "" : "hidden"}>
        Books
      </FooterListTitle>

      <FooterListButton href="https://www.amazon.com/gp/product/B08MQVKB1Q">
        <AutoStoriesIcon />
        The Forgotten Adoption Option
      </FooterListButton>

      <FooterListButton href="https://www.amazon.com/What-Know-Adopt-Through-Foster-ebook/dp/B0CKZJWMMD?ref_=ast_author_mpb">
        <AutoStoriesIcon />
        What to Know When You Adopt Through Foster Care
      </FooterListButton>

      <FooterListButton href="https://www.amazon.com/Its-Okay-Talk-About-Adoption-ebook/dp/B0G1C7HG9N">
        <AutoStoriesIcon />
        It&apos;s Okay to Talk About Adoption
      </FooterListButton>

      <FooterListButton href="https://www.amazon.com/Are-Forever-Family-Marcy-Bursac-ebook/dp/B09Y67NHSF">
        <AutoStoriesIcon />
        Are You a Forever Family?
      </FooterListButton>

      <FooterListButton href="https://www.amazon.com/Ready-Not-Never-Asked-This/dp/B0GZSXNM7H">
        <AutoStoriesIcon />
        Ready or Not?
      </FooterListButton>
    </ul>
  );
}
